// import ExampleColorPicker from './exampleColorPicker';

export function EditThemeContent() {
  return (
    <>
      <div className='bg-white overflow-hidden shadow-md rounded-lg px-4 py-4'>
        {/* <ExampleColorPicker /> */} NAS
      </div>
    </>
  );
}

// GET style theme by id from DB to Oper in ExampleColorTheme
